export default "__VITE_ASSET__punb3uBr__"